module.exports = __webpack_public_path__ + "img/logo.14fe5a76.png";